/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ExclamationCircle: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8.8 11.8C8.6 12 8.3 12.1 8 12.1C7.7 12.1 7.4 12 7.2 11.8C7 11.6 6.9 11.3 6.9 11C6.9 10.7 7 10.4 7.2 10.2C7.4 10 7.7 9.9 8 9.9C8.3 9.9 8.6 10 8.8 10.2C9 10.4 9.1 10.7 9.1 11C9.1 11.3 9 11.5 8.8 11.8ZM8.3 8.9C8.5 8.9 8.6 8.7 8.6 8.6C8.66667 8.06666 8.74444 7.53333 8.82222 6.99999C8.97778 5.93333 9.13333 4.86666 9.2 3.8C9.2 3.56261 9.07477 3.45045 8.92341 3.31489C8.88349 3.27913 8.84174 3.24174 8.8 3.2C8.73739 3.17913 8.67913 3.15826 8.62341 3.1383C8.41216 3.06261 8.23739 3 8 3C7.9 3 7.7 3 7.5 3.1C7.3 3.2 7.1 3.3 7 3.4C6.9 3.5 6.8 3.6 6.8 3.8C6.84654 4.45161 6.93641 5.14654 7.02928 5.86464C7.13594 6.68939 7.24654 7.5447 7.3 8.4C7.3 8.5 7.4 8.7 7.5 8.8C7.6 8.9 7.7 9 7.9 9C8.1 9 8.2 9 8.3 8.9Z'
			/>
		</Svg>
	);
};

export { ExclamationCircle };
